import * as React from 'react';

export interface IAuthPageProps extends React.PropsWithChildren {}

export const AuthPage: React.FunctionComponent<IAuthPageProps> = props => {
  return (
    <div className='container relative h-screen flex-col items-center justify-center px-0 lg:grid lg:max-w-none lg:grid-cols-2'>
      {props.children}
    </div>
  );
};
